import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/ui'
import InstructorForm from '@/features/instructors/InstructorForm'
import type { Instructor } from '@/types/api'

/**
 * Nový inštruktor mimo kalendára.
 *
 * Inštruktor sa prijíma pred sezónou, nie pri zakladaní prvého bloku - to je
 * jediný okamih, kedy sa dal doteraz založiť.
 *
 * Poradie v kalendári sa nenastavuje: nový ide na koniec a presúva sa až
 * v zozname, kde je vidieť ostatných. Kód do Messengera dostane hneď pri
 * uložení (server volá `ensure_hash`).
 */
export default function NewInstructorModal({
  onClose,
  onCreated,
}: {
  onClose: () => void
  onCreated?: (instructor: Instructor) => void
}) {
  const { t } = useTranslation()

  return (
    <Modal open onClose={onClose} size="md" title={t('instructors.create')}>
      <InstructorForm
        onDone={(instructor) => {
          // `onDone` sa volá aj pri zrušení - vtedy bez inštruktora.
          if (instructor && onCreated) onCreated(instructor)
          onClose()
        }}
      />
    </Modal>
  )
}
